import { SnackbarProps } from '@mui/material/Snackbar';
import { MuiSnackbarVariant } from 'components/MuiExtras/Snackbar/MuiSnackbarContent';
import * as React from 'react';

export type SnackbarHandleActionType = () => void;

export type SnackbarShowMessage = (message: React.ReactNode, variant?: MuiSnackbarVariant, action?: string, handleAction?: SnackbarHandleActionType) => void;

export type WithSnackbarParamsType = {
    showMessage: SnackbarShowMessage;
};

export interface WithSnackbar {
    snackbar: WithSnackbarParamsType;
}

export interface ISnackbarProviderProps extends React.ComponentPropsWithoutRef<any> {
    SnackbarProps: Omit<SnackbarProps, "open" | "autoHideDuration">;
}

const ctxt = React.createContext<WithSnackbarParamsType>({
    showMessage: (message, color, action, handleAction) => {
        throw new Error('showMessage() not implemented');
    }
});

export function withSnackbar<P extends WithSnackbar, R = Subtract<P, WithSnackbar>>(Component: React.ComponentClass<P> | React.StatelessComponent<P>): React.FC<R> {
    return function BoundComponent(props: P & R) {
        return (
            <SnackbarContextConsumer>
                {value => <Component {...props} snackbar={value} />}
            </SnackbarContextConsumer>
        );
    };
}


export const SnackbarContextProvider = ctxt.Provider;

export const SnackbarContextConsumer = ctxt.Consumer;